














































































import { Component, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import {
  ForgotPasswordModel,
  forgotModel,
  forgotFields,
  forgotFieldsValidation,
} from '@shared/models/LoginModels/ForgotPasswordModel';
import SimpleLayoutAbstract from '@shared/views/LoginLayouts/SimpleLayout.abstract';
import { parseErrors } from '@shared/helpers/common.helper';
import { ServerErrorsModel } from '@shared/models/Common/ServerErrorsModel';

@Component
export default class Forgot extends SimpleLayoutAbstract {
  @Prop({ required: true })
  api: any;

  @Validations()
  validations = {
    model: forgotFieldsValidation,
  };

  model: ForgotPasswordModel = forgotModel;

  fields = forgotFields;

  private results = {
    error: 0,
    success: 1,
  };

  public result = -1;

  public serverErrors: string[] = [];

  public loading = false;

  submit() {
    this.$v.model.$touch();

    if (this.isFormInvalid) return;
    this.loading = true;

    this.api.accountForgotPassword(this.model).then(() => {
      this.result = this.results.success;
    }).catch((error: any) => {
      this.serverErrors = parseErrors(error.response.data.errors as ServerErrorsModel);
      this.result = this.results.error;
    }).finally(() => {
      this.loading = false;
    });
  }
}
